import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, Heading, Image, Input } from "@chakra-ui/react";
import { API_URL } from "../../Apis/config";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState(process.env.REACT_APP_DEV_ADMIN_EMAIL || "");
  const [password, setPassword] = useState(process.env.REACT_APP_DEV_ADMIN_PASSWORD || "");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const login = () => {
    let isValid = true;
    setUsernameError("");
    setPasswordError("");

    if (username.trim() === "") {
      setUsernameError("Please enter your username");
      isValid = false;
    }

    if (password.trim() === "") {
      setPasswordError("Please enter your password");
      isValid = false;
    }

    if (isValid) {
      const payload = { email: username, password };
      axios
        .post(`${API_URL}/admin/login`, payload)
        .then((res) => {
          if (res.data === "64b8e74a35b59267dc7caebf") {
            localStorage.setItem("AdminToken", res.data);
            toast.success("Login successful");
            navigate("/admin/welcome");
          } else {
            toast.error("Wrong password or email");
          }
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("AdminToken");
    if (token === "64b8e74a35b59267dc7caebf") {
      navigate("/admin/welcome");
    }
  }, []);

  return (
    <Flex minH="100vh" bg="kumkum.500" align="center" justify="center" p={4}>
      <Box as="main" w="100%" maxW="400px">
        <Box bg="white" borderRadius="lg" p={6}>
          <Heading as="h1" mb={6}>
            <Image
              src={`${process.env.PUBLIC_URL}/logo-full.png`}
              alt="Datta Sai Astro & Priest Service"
              w="200px"
              mx="auto"
            />
          </Heading>
          <FormControl isInvalid={Boolean(usernameError)} mb={4}>
            <FormLabel>Email</FormLabel>
            <Input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <FormErrorMessage>{usernameError}</FormErrorMessage>
          </FormControl>
          <FormControl isInvalid={Boolean(passwordError)} mb={5}>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <FormErrorMessage>{passwordError}</FormErrorMessage>
          </FormControl>
          <Button width="100%" onClick={login}>
            Log in
          </Button>
        </Box>
      </Box>
      <ToastContainer />
    </Flex>
  );
};

export default AdminLogin;
